import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { LoopBackAuth } from '../shared/sdk/services/core';

import { CustomerApi } from '../shared/sdk/services/custom/';
import { ContextService } from '../auth/context.service';

import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(private translate: TranslateService,
                private router: Router,
                private loopBackAuth: LoopBackAuth,
                private customerApi: CustomerApi) { }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentUser = this.loopBackAuth.getCurrentUserData();
        const remember = this.loopBackAuth.getToken().rememberMe;

        if (currentUser && remember) {
          try {
            // get current customer data from accessToken
            const customer = await this.customerApi.current().toPromise();

            // set context customer
            ContextService.context.customer = customer;

            // set context customer language and trasnlator
            ContextService.context.language = customer.language;

            //set language translator
            this.translate.use(customer.language);

            // set context customer area
            ContextService.context.area = customer.defaultArea;
            // ContextService.context.area = customer.areas[0];

            // authorised so return true
            return true;
          } catch (err) {
            console.log(err)

            this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
            return false;
          }
        }
        else {
          this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
          return false;
        }
    }
}
